// src/components/Style/GBDirectionalPadStyle.js

// ルート Box（Dパッド全体の外枠）
export const DIRECTIONAL_PAD_ROOT_BOX_SX = {
    m: 1,
    p: 4,
};

// 上ボタン
export const DIRECTIONAL_PAD_UP_BUTTON_SX = {
    m: 1,
    p: 1,
    bgcolor: '#000000',
    height: '25px',
    width: '25px',
    fontSize: '20px',
    position: 'absolute',
    top: '450px',
    left: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333631',
};

// 左ボタン
export const DIRECTIONAL_PAD_LEFT_BUTTON_SX = {
    m: 1,
    p: 1,
    bgcolor: '#000000',
    height: '25px',
    width: '25px',
    fontSize: '20px',
    position: 'absolute',
    top: '490px',
    left: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333631',
    transform: 'rotate(270deg)',
};

// 右ボタン
export const DIRECTIONAL_PAD_RIGHT_BUTTON_SX = {
    m: 1,
    p: 1,
    bgcolor: '#000000',
    height: '25px',
    width: '25px',
    fontSize: '20px',
    position: 'absolute',
    top: '490px',
    left: '95px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333631',
    transform: 'rotate(90deg)',
};

// 下ボタン
export const DIRECTIONAL_PAD_DOWN_BUTTON_SX = {
    m: 1,
    p: 1,
    bgcolor: '#000000',
    height: '25px',
    width: '25px',
    fontSize: '20px',
    position: 'absolute',
    top: '530px',
    left: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333631',
};

// 中央ボタン
export const DIRECTIONAL_PAD_CENTER_BUTTON_SX = {
    m: 1,
    p: 1,
    bgcolor: '#000000',
    height: '25px',
    width: '25px',
    fontSize: '20px',
    position: 'absolute',
    top: '490px',
    left: '55px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#333631',
};
